<!-- Template for dialogService -->
<div class="modal-header">
  <h4>{{ title }}</h4>
</div>
<div class="modal-body">
  {{ body }}
</div>
<div class="modal-footer">
  <button class="btn btn-default" data-ng-click="activeModal.close();">{{ 'button_close' | l10n }}</button>
</div>
